var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"cssid":"tutorial"},on:{"escape":_vm.close}},[_c('div',{staticClass:"container"},[_vm._t("default")],2),_c('button',{staticClass:"modal-button",on:{"click":_vm.close}},[_vm._v("Close")])])}
var staticRenderFns = []

export { render, staticRenderFns }